/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 9 5',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#000" fill-rule="nonzero"><path pid="0" d="M3.227 3.227a.996.996 0 0 1 .605-.288L6.47.301a1 1 0 0 1 1.414 1.414L4.959 4.641a1.224 1.224 0 0 1-1.732 0 1 1 0 0 1 0-1.414zm1.414 0a1 1 0 0 1-1.414 1.414L.293 1.707A1 1 0 0 1 1.707.293l2.934 2.934z"/></g></g>'
  }
})
